<template>
  <NuxtLink class="blog-article-card" :href="`/news/${url}${backTo ? `?backTo=${backTo}` : ''}`">
    <div class="blog-article-card__thumbnail" :style="{ backgroundImage: `url(${backgroundImage})` }">
    </div>
    <div class="blog-article-card__properties">
      <p class="blog-article-property" v-for="property in properties" :key="property.icon">
        <i class="fa-solid blog-article-property__icon" :class="property.icon" v-if="property.icon"/>
        <span class="blog-article-property__value">{{ property.value }}</span>
      </p>
    </div>
    <div>
      <p class="blog-article-card__title">{{ title }}</p>
      <p class="blog-article-card__description" v-if="extended">{{ shortDescription }}</p>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
export interface BlogArticleCardProps {
  backgroundImage: string,
  publishedAt: Date,
  title: string,
  views: number,
  extended?: boolean,
  shortDescription: string,
  url: string,
  type: string,
  backTo?: string,
}

const props = withDefaults(defineProps<BlogArticleCardProps>(), {
  extended: false,
});

const properties = computed(() => [
  // {
  //   value: props.type.toUpperCase()
  // },
  {
    icon: 'fa-calendar',
    value: props.publishedAt.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  },
])
</script>

<style scoped lang="scss">
.blog-article-card {
  text-decoration: none;

  transition: all 200ms ease-out;

  &:hover {
    transform: scale(1.01);
  }

  &__thumbnail {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    padding: 8px 12px;
    box-sizing: border-box;

    background-size: cover;
    background-position: center center;
    aspect-ratio: 16 / 9;

    border-radius: 16px;
  }

  &__title {
    margin-top: 4px;

    color: #212529;
    font-family: var(--font-family-main);
    font-size: 26px;
    font-weight: 700;
    line-height: 1;
    text-transform: uppercase;
  }

  &__description {
    margin-top: 8px;

    color: #212529;
    font-family: var(--font-family-main);
    font-size: 18px;
    font-weight: 500;
    line-height: 1.2;
  }

  &__properties {
    display: flex;
    align-items: center;
    gap: 8px;

    margin-top: 8px;
    margin-bottom: 4px;
  }
}

.blog-article-property {
  display: flex;
  align-items: center;
  gap: 8px;

  //padding: 6px 12px;

  //color: white;
  color: #212529;
  opacity: 0.5;

  //background-color: #E43233;
  //border-radius: 16px;
  //box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);

  &__icon {
    font-family: "Font Awesome 6 Free", sans-serif;
    font-size: 12px;
    font-weight: 900;
    white-space: nowrap;
  }

  &__value {
    font-family: var(--font-family-main);
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
  }
}
</style>